// Home's Reports widget (DS row 65's last slot; CR-040 "Reporting events -> Read model -> Persona dashboard ->
// Drill-down/export"): the report families this reader may open (S13 lists them from `families_for`, so the Interviewer
// gets none and an HM gets their own-reqs families), each a link to its tab in his report names. A family whose name is
// not in his glossary yet is left out rather than drawn in a word he has not given.

import { Row, RowName, Stack, Widget } from "@/mc";
import { NAV_ITEM_LABELS } from "@/mc/labels";
import { reportHref } from "@/views/b10/reports/spec";
import type { HomeWidgetView } from "./host";
import { reportsOf, seatsOf, type ReportsData } from "./api";
import { REPORT_FAMILY_LABELS } from "./labels";
import { hsKey } from "@/views/b10/lib/hsKey";

const FAMILY_WORDS: Readonly<Record<string, string>> = REPORT_FAMILY_LABELS;

export function ReportsBody({ data }: { data: ReportsData }) {
  const families = data.families.filter((family) => FAMILY_WORDS[family.key]);
  return (
    <Stack gap={0}>
      {families.map((family) => (
        <Row key={family.key} cols={1} href={family.route || reportHref(family.key)} hs={hsKey("dash.reports", family.key)}>
          <RowName name={FAMILY_WORDS[family.key]} />
        </Row>
      ))}
    </Stack>
  );
}

/** Widget `reports` (S13 → S16, frozen). */
export const ReportsLinks: HomeWidgetView = ({ widgetKey, data }) => {
  const reports = reportsOf(data);
  if (!reports.families.some((family) => FAMILY_WORDS[family.key])) return null;
  return (
    <Widget id={widgetKey} kind="reports" roles={seatsOf(widgetKey)} title={NAV_ITEM_LABELS.reports}>
      <ReportsBody data={reports} />
    </Widget>
  );
};
